var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 19.2C4.7496 18.6405 7.08947 16.0656 7.77517 16.0656H15.0253C16.0189 16.0656 18.0473 18.2 18.55 18.9524M21.8 11.4C21.8 17.1438 17.1438 21.8 11.4 21.8C5.65624 21.8 1 17.1438 1 11.4C1 5.65624 5.65624 1 11.4 1C17.1438 1 21.8 5.65624 21.8 11.4ZM15.1254 7.85529C15.1254 5.87115 13.4504 4.25 11.4003 4.25C9.35024 4.25 7.67522 5.87115 7.67522 7.85529C7.67522 9.83943 9.35024 11.4606 11.4003 11.4606C13.4504 11.4606 15.1254 9.83943 15.1254 7.85529Z",
    stroke: "#0F0F30",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoUser);
export default __webpack_public_path__ + "static/media/trvto_user.c0fcc7fd42351a4ed011ae94289002ab.svg";
export { ForwardRef as ReactComponent };